import { g as Be, v as We, A as ve, c as $e } from "./sdk-DQE-jrdj.js";
import { b as Qt, a as qt } from "./sdk-DQE-jrdj.js";
import { jsx as Ke } from "react/jsx-runtime";
import G, { useEffect as ye, createContext as Qe, useContext as qe, useRef as Je, useCallback as Xe } from "react";
const Ye = {}, Ee = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (a, l) => {
    const d = typeof a == "function" ? a(t) : a;
    if (!Object.is(d, t)) {
      const s = t;
      t = l ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((p) => p(t, s));
    }
  }, o = () => t, f = { setState: r, getState: o, getInitialState: () => m, subscribe: (a) => (n.add(a), () => n.delete(a)), destroy: () => {
    (Ye ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, m = t = e(r, o, f);
  return f;
}, Ze = (e) => e ? Ee(e) : Ee;
var H = { exports: {} }, ee = {}, B = { exports: {} }, te = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Se;
function et() {
  if (Se) return te;
  Se = 1;
  var e = G;
  function t(l, d) {
    return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, _ = e.useDebugValue;
  function c(l, d) {
    var s = d(), p = r({ inst: { value: s, getSnapshot: d } }), u = p[0].inst, v = p[1];
    return i(
      function() {
        u.value = s, u.getSnapshot = d, f(u) && v({ inst: u });
      },
      [l, s, d]
    ), o(
      function() {
        return f(u) && v({ inst: u }), l(function() {
          f(u) && v({ inst: u });
        });
      },
      [l]
    ), _(s), s;
  }
  function f(l) {
    var d = l.getSnapshot;
    l = l.value;
    try {
      var s = d();
      return !n(l, s);
    } catch {
      return !0;
    }
  }
  function m(l, d) {
    return d();
  }
  var a = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? m : c;
  return te.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : a, te;
}
var ne = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ge;
function tt() {
  return ge || (ge = 1, process.env.NODE_ENV !== "production" && function() {
    function e(s, p) {
      return s === p && (s !== 0 || 1 / s === 1 / p) || s !== s && p !== p;
    }
    function t(s, p) {
      a || o.startTransition === void 0 || (a = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var u = p();
      if (!l) {
        var v = p();
        i(u, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), l = !0);
      }
      v = _({
        inst: { value: u, getSnapshot: p }
      });
      var y = v[0].inst, h = v[1];
      return f(
        function() {
          y.value = u, y.getSnapshot = p, n(y) && h({ inst: y });
        },
        [s, u, p]
      ), c(
        function() {
          return n(y) && h({ inst: y }), s(function() {
            n(y) && h({ inst: y });
          });
        },
        [s]
      ), m(u), u;
    }
    function n(s) {
      var p = s.getSnapshot;
      s = s.value;
      try {
        var u = p();
        return !i(s, u);
      } catch {
        return !0;
      }
    }
    function r(s, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = G, i = typeof Object.is == "function" ? Object.is : e, _ = o.useState, c = o.useEffect, f = o.useLayoutEffect, m = o.useDebugValue, a = !1, l = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    ne.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ne;
}
var be;
function Ne() {
  return be || (be = 1, process.env.NODE_ENV === "production" ? B.exports = et() : B.exports = tt()), B.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function nt() {
  if (Oe) return ee;
  Oe = 1;
  var e = G, t = Ne();
  function n(m, a) {
    return m === a && (m !== 0 || 1 / m === 1 / a) || m !== m && a !== a;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, i = e.useRef, _ = e.useEffect, c = e.useMemo, f = e.useDebugValue;
  return ee.useSyncExternalStoreWithSelector = function(m, a, l, d, s) {
    var p = i(null);
    if (p.current === null) {
      var u = { hasValue: !1, value: null };
      p.current = u;
    } else u = p.current;
    p = c(
      function() {
        function y(S) {
          if (!h) {
            if (h = !0, g = S, S = d(S), s !== void 0 && u.hasValue) {
              var O = u.value;
              if (s(O, S))
                return w = O;
            }
            return w = S;
          }
          if (O = w, r(g, S)) return O;
          var F = d(S);
          return s !== void 0 && s(O, F) ? (g = S, O) : (g = S, w = F);
        }
        var h = !1, g, w, D = l === void 0 ? null : l;
        return [
          function() {
            return y(a());
          },
          D === null ? void 0 : function() {
            return y(D());
          }
        ];
      },
      [a, l, d, s]
    );
    var v = o(m, p[0], p[1]);
    return _(
      function() {
        u.hasValue = !0, u.value = v;
      },
      [v]
    ), f(v), v;
  }, ee;
}
var re = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function rt() {
  return Ue || (Ue = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m, a) {
      return m === a && (m !== 0 || 1 / m === 1 / a) || m !== m && a !== a;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = G, n = Ne(), r = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, i = t.useRef, _ = t.useEffect, c = t.useMemo, f = t.useDebugValue;
    re.useSyncExternalStoreWithSelector = function(m, a, l, d, s) {
      var p = i(null);
      if (p.current === null) {
        var u = { hasValue: !1, value: null };
        p.current = u;
      } else u = p.current;
      p = c(
        function() {
          function y(S) {
            if (!h) {
              if (h = !0, g = S, S = d(S), s !== void 0 && u.hasValue) {
                var O = u.value;
                if (s(O, S))
                  return w = O;
              }
              return w = S;
            }
            if (O = w, r(g, S))
              return O;
            var F = d(S);
            return s !== void 0 && s(O, F) ? (g = S, O) : (g = S, w = F);
          }
          var h = !1, g, w, D = l === void 0 ? null : l;
          return [
            function() {
              return y(a());
            },
            D === null ? void 0 : function() {
              return y(D());
            }
          ];
        },
        [a, l, d, s]
      );
      var v = o(m, p[0], p[1]);
      return _(
        function() {
          u.hasValue = !0, u.value = v;
        },
        [v]
      ), f(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), re;
}
var Ie;
function ot() {
  return Ie || (Ie = 1, process.env.NODE_ENV === "production" ? H.exports = nt() : H.exports = rt()), H.exports;
}
var st = ot();
const at = /* @__PURE__ */ Be(st), ze = {}, { useDebugValue: it } = G, { useSyncExternalStoreWithSelector: ut } = at;
let Ae = !1;
const ct = (e) => e;
function C(e, t = ct, n) {
  (ze ? "production" : void 0) !== "production" && n && !Ae && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), Ae = !0);
  const r = ut(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return it(r), r;
}
const Ce = (e) => {
  (ze ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? Ze(e) : e, n = (r, o) => C(t, r, o);
  return Object.assign(n, t), n;
}, lt = (e) => e ? Ce(e) : Ce, oe = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, ue = /* @__PURE__ */ new Map(), W = (e) => {
  const t = ue.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, dt = (e, t, n) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(n)
    };
  const r = ue.get(n.name);
  if (r)
    return { type: "tracked", store: e, ...r };
  const o = {
    connection: t.connect(n),
    stores: {}
  };
  return ue.set(n.name, o), { type: "tracked", store: e, ...o };
}, ft = (e, t = {}) => (n, r, o) => {
  const { enabled: i, anonymousActionType: _, store: c, ...f } = t;
  let m;
  try {
    m = (i ?? (oe ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!m)
    return (oe ? "production" : void 0) !== "production" && i && console.warn(
      "[zustand devtools middleware] Please install/enable Redux devtools extension"
    ), e(n, r, o);
  const { connection: a, ...l } = dt(c, m, f);
  let d = !0;
  o.setState = (u, v, y) => {
    const h = n(u, v);
    if (!d) return h;
    const g = y === void 0 ? { type: _ || "anonymous" } : typeof y == "string" ? { type: y } : y;
    return c === void 0 ? (a == null || a.send(g, r()), h) : (a == null || a.send(
      {
        ...g,
        type: `${c}/${g.type}`
      },
      {
        ...W(f.name),
        [c]: o.getState()
      }
    ), h);
  };
  const s = (...u) => {
    const v = d;
    d = !1, n(...u), d = v;
  }, p = e(o.setState, r, o);
  if (l.type === "untracked" ? a == null || a.init(p) : (l.stores[l.store] = o, a == null || a.init(
    Object.fromEntries(
      Object.entries(l.stores).map(([u, v]) => [
        u,
        u === l.store ? p : v.getState()
      ])
    )
  )), o.dispatchFromDevtools && typeof o.dispatch == "function") {
    let u = !1;
    const v = o.dispatch;
    o.dispatch = (...y) => {
      (oe ? "production" : void 0) !== "production" && y[0].type === "__setState" && !u && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), u = !0), v(...y);
    };
  }
  return a.subscribe((u) => {
    var v;
    switch (u.type) {
      case "ACTION":
        if (typeof u.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return se(
          u.payload,
          (y) => {
            if (y.type === "__setState") {
              if (c === void 0) {
                s(y.state);
                return;
              }
              Object.keys(y.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const h = y.state[c];
              if (h == null)
                return;
              JSON.stringify(o.getState()) !== JSON.stringify(h) && s(h);
              return;
            }
            o.dispatchFromDevtools && typeof o.dispatch == "function" && o.dispatch(y);
          }
        );
      case "DISPATCH":
        switch (u.payload.type) {
          case "RESET":
            return s(p), c === void 0 ? a == null ? void 0 : a.init(o.getState()) : a == null ? void 0 : a.init(W(f.name));
          case "COMMIT":
            if (c === void 0) {
              a == null || a.init(o.getState());
              return;
            }
            return a == null ? void 0 : a.init(W(f.name));
          case "ROLLBACK":
            return se(u.state, (y) => {
              if (c === void 0) {
                s(y), a == null || a.init(o.getState());
                return;
              }
              s(y[c]), a == null || a.init(W(f.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return se(u.state, (y) => {
              if (c === void 0) {
                s(y);
                return;
              }
              JSON.stringify(o.getState()) !== JSON.stringify(y[c]) && s(y[c]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: y } = u.payload, h = (v = y.computedStates.slice(-1)[0]) == null ? void 0 : v.state;
            if (!h) return;
            s(c === void 0 ? h : h[c]), a == null || a.send(
              null,
              // FIXME no-any
              y
            );
            return;
          }
          case "PAUSE_RECORDING":
            return d = !d;
        }
        return;
    }
  }), p;
}, pt = ft, se = (e, t) => {
  let n;
  try {
    n = JSON.parse(e);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && t(n);
};
var ke = Symbol.for("immer-nothing"), we = Symbol.for("immer-draftable"), U = Symbol.for("immer-state"), _t = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function b(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = _t[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var k = Object.getPrototypeOf;
function M(e) {
  return !!e && !!e[U];
}
function T(e) {
  var t;
  return e ? Me(e) || Array.isArray(e) || !!e[we] || !!((t = e.constructor) != null && t[we]) || J(e) || X(e) : !1;
}
var yt = Object.prototype.constructor.toString();
function Me(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = k(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === yt;
}
function $(e, t) {
  q(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function q(e) {
  const t = e[U];
  return t ? t.type_ : Array.isArray(e) ? 1 : J(e) ? 2 : X(e) ? 3 : 0;
}
function ce(e, t) {
  return q(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Fe(e, t, n) {
  const r = q(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function mt(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function J(e) {
  return e instanceof Map;
}
function X(e) {
  return e instanceof Set;
}
function L(e) {
  return e.copy_ || e.base_;
}
function le(e, t) {
  if (J(e))
    return new Map(e);
  if (X(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = Me(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[U];
    let o = Reflect.ownKeys(r);
    for (let i = 0; i < o.length; i++) {
      const _ = o[i], c = r[_];
      c.writable === !1 && (c.writable = !0, c.configurable = !0), (c.get || c.set) && (r[_] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: c.enumerable,
        value: e[_]
      });
    }
    return Object.create(k(e), r);
  } else {
    const r = k(e);
    if (r !== null && n)
      return { ...e };
    const o = Object.create(r);
    return Object.assign(o, e);
  }
}
function me(e, t = !1) {
  return Y(e) || M(e) || !T(e) || (q(e) > 1 && (e.set = e.add = e.clear = e.delete = ht), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => me(r, !0))), e;
}
function ht() {
  b(2);
}
function Y(e) {
  return Object.isFrozen(e);
}
var vt = {};
function N(e) {
  const t = vt[e];
  return t || b(0, e), t;
}
var j;
function xe() {
  return j;
}
function Et(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function De(e, t) {
  t && (N("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function de(e) {
  fe(e), e.drafts_.forEach(St), e.drafts_ = null;
}
function fe(e) {
  e === j && (j = e.parent_);
}
function Pe(e) {
  return j = Et(j, e);
}
function St(e) {
  const t = e[U];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Re(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[U].modified_ && (de(t), b(4)), T(e) && (e = K(t, e), t.parent_ || Q(t, e)), t.patches_ && N("Patches").generateReplacementPatches_(
    n[U].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = K(t, n, []), de(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== ke ? e : void 0;
}
function K(e, t, n) {
  if (Y(t))
    return t;
  const r = t[U];
  if (!r)
    return $(
      t,
      (o, i) => Le(e, r, t, o, i, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return Q(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const o = r.copy_;
    let i = o, _ = !1;
    r.type_ === 3 && (i = new Set(o), o.clear(), _ = !0), $(
      i,
      (c, f) => Le(e, r, o, c, f, n, _)
    ), Q(e, o, !1), n && e.patches_ && N("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function Le(e, t, n, r, o, i, _) {
  if (process.env.NODE_ENV !== "production" && o === n && b(5), M(o)) {
    const c = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ce(t.assigned_, r) ? i.concat(r) : void 0, f = K(e, o, c);
    if (Fe(n, r, f), M(f))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else _ && n.add(o);
  if (T(o) && !Y(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    K(e, o), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && Q(e, o);
  }
}
function Q(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && me(t, n);
}
function gt(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : xe(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = he;
  n && (o = [r], i = V);
  const { revoke: _, proxy: c } = Proxy.revocable(o, i);
  return r.draft_ = c, r.revoke_ = _, c;
}
var he = {
  get(e, t) {
    if (t === U)
      return e;
    const n = L(e);
    if (!ce(n, t))
      return bt(e, n, t);
    const r = n[t];
    return e.finalized_ || !T(r) ? r : r === ae(e.base_, t) ? (ie(e), e.copy_[t] = _e(r, e)) : r;
  },
  has(e, t) {
    return t in L(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(L(e));
  },
  set(e, t, n) {
    const r = je(L(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = ae(L(e), t), i = o == null ? void 0 : o[U];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (mt(n, o) && (n !== void 0 || ce(e.base_, t)))
        return !0;
      ie(e), pe(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return ae(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, ie(e), pe(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = L(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    b(11);
  },
  getPrototypeOf(e) {
    return k(e.base_);
  },
  setPrototypeOf() {
    b(12);
  }
}, V = {};
$(he, (e, t) => {
  V[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
V.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && b(13), V.set.call(this, e, t, void 0);
};
V.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && b(14), he.set.call(this, e[0], t, n, e[0]);
};
function ae(e, t) {
  const n = e[U];
  return (n ? L(n) : e)[t];
}
function bt(e, t, n) {
  var o;
  const r = je(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function je(e, t) {
  if (!(t in e))
    return;
  let n = k(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = k(n);
  }
}
function pe(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && pe(e.parent_));
}
function ie(e) {
  e.copy_ || (e.copy_ = le(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var Ot = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const _ = this;
        return function(f = i, ...m) {
          return _.produce(f, (a) => n.call(this, a, ...m));
        };
      }
      typeof n != "function" && b(6), r !== void 0 && typeof r != "function" && b(7);
      let o;
      if (T(t)) {
        const i = Pe(this), _ = _e(t, void 0);
        let c = !0;
        try {
          o = n(_), c = !1;
        } finally {
          c ? de(i) : fe(i);
        }
        return De(i, r), Re(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === ke && (o = void 0), this.autoFreeze_ && me(o, !0), r) {
          const i = [], _ = [];
          N("Patches").generateReplacementPatches_(t, o, i, _), r(i, _);
        }
        return o;
      } else
        b(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (_, ...c) => this.produceWithPatches(_, (f) => t(f, ...c));
      let r, o;
      return [this.produce(t, n, (_, c) => {
        r = _, o = c;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    T(e) || b(8), M(e) && (e = Ut(e));
    const t = Pe(this), n = _e(e, void 0);
    return n[U].isManual_ = !0, fe(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[U];
    (!n || !n.isManual_) && b(9);
    const { scope_: r } = n;
    return De(r, t), Re(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = N("Patches").applyPatches_;
    return M(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function _e(e, t) {
  const n = J(e) ? N("MapSet").proxyMap_(e, t) : X(e) ? N("MapSet").proxySet_(e, t) : gt(e, t);
  return (t ? t.scope_ : xe()).drafts_.push(n), n;
}
function Ut(e) {
  return M(e) || b(10, e), Ve(e);
}
function Ve(e) {
  if (!T(e) || Y(e))
    return e;
  const t = e[U];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = le(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = le(e, !0);
  return $(n, (r, o) => {
    Fe(n, r, Ve(o));
  }), t && (t.finalized_ = !1), n;
}
var I = new Ot(), Te = I.produce;
I.produceWithPatches.bind(
  I
);
I.setAutoFreeze.bind(I);
I.setUseStrictShallowCopy.bind(I);
I.applyPatches.bind(I);
I.createDraft.bind(I);
I.finishDraft.bind(I);
var E = /* @__PURE__ */ ((e) => (e.Disabled = "DISABLED", e.Pending = "PENDING", e.Queued = "QUEUED", e.Uploading = "UPLOADING", e.Uploaded = "UPLOADED", e.Cancelled = "CANCELLED", e.Failed = "FAILED", e.Paused = "PAUSED", e))(E || {}), A = /* @__PURE__ */ ((e) => (e.None = "NONE", e.Pending = "PENDING", e.Queued = "QUEUED", e.Calculating = "CALCULATING", e.Complete = "COMPLETE", e.Error = "ERROR", e.Cancelled = "CANCELLED", e))(A || {});
const It = [E.Pending, E.Uploading];
function z(e) {
  const t = e.uploads.find((r) => r.status === E.Queued), n = e.uploads.filter(
    (r) => It.includes(r.status)
  ).length;
  t && n < e.maxConcurrentUploads && (t.status = E.Pending);
}
function x(e) {
  const t = e.uploads.find((r) => r.hash.status === A.Queued), n = e.uploads.some(({ hash: r }) => r.status === A.Calculating);
  t && !n && (t.hash.status = A.Pending);
}
const Ge = {
  instanceId: "",
  fileNames: [],
  uploads: [],
  uploadedCount: 0,
  metadata: {},
  thumbnail: {},
  maxConcurrentUploads: 0,
  withHashing: !1
};
function At(e, t) {
  switch (t.type) {
    case "init":
      return { ...Ge, instanceId: t.payload.instanceId };
    case "onFileAdded": {
      e.fileNames.push(t.payload.file.name);
      break;
    }
    case "onAssetAssigned": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n && (n.assetId = t.payload.detail.assetId, n.fileId = t.payload.detail.fileId);
      break;
    }
    case "onUploadCreated": {
      e.uploads.push({
        ...t.payload.detail,
        status: E.Disabled,
        uploaded: 0,
        progress: 0,
        hash: {
          status: e.withHashing ? A.Pending : A.None
        }
      }), x(e);
      break;
    }
    case "onUploadQueued": {
      const n = e.uploads.find((r) => r.uploadId === t.payload.uploadId);
      if (!n || n.status !== E.Disabled)
        break;
      n.status = E.Queued, z(e);
      break;
    }
    case "onQueueingAllUploads": {
      e.uploads.forEach((n) => {
        n.status === E.Disabled && (n.status = E.Queued, z(e));
      });
      break;
    }
    case "onUploadProgress": {
      const { uploadId: n, bytesUploaded: r } = t.payload.detail, o = e.uploads.find((i) => i.uploadId === n);
      if (!o || o.file.size === 0)
        break;
      o.status = E.Uploading, o.uploaded = r, o.progress = Math.ceil(o.uploaded / o.file.size * 100);
      break;
    }
    case "onUploadComplete": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n && (n.assetId = t.payload.detail.assetId, n.fileId = t.payload.detail.fileId, n.status = E.Uploaded, e.uploadedCount += 1, z(e));
      break;
    }
    case "onUploadCancelled": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n && (n.status = E.Cancelled, z(e));
      break;
    }
    case "onUploadRemoved": {
      const n = e.uploads.findIndex(
        (r) => r.uploadId === t.payload.uploadId
      );
      if (n > -1) {
        const r = e.uploads[n].uploadId;
        e.uploads.splice(n, 1), delete e.metadata[r], z(e);
      }
      break;
    }
    case "onError": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n && (n.status = E.Failed, n.error = t.payload.detail.error, z(e));
      break;
    }
    case "onMetadataReceived": {
      e.metadata[t.payload.detail.uploadId] = t.payload.detail.metadata;
      break;
    }
    case "onThumbnailReceived": {
      e.thumbnail[t.payload.detail.uploadId] = t.payload.detail.thumbnailUrl;
      break;
    }
    case "onHashComplete": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n != null && n.hash && (n.hash = {
        ...n.hash,
        md5: t.payload.detail.hash,
        status: A.Complete
      }), x(e);
      break;
    }
    case "onHashError": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n != null && n.hash && (n.hash = {
        ...n.hash,
        status: A.Error,
        error: t.payload.detail.error
      }), x(e);
      break;
    }
    case "onHashCancelled": {
      const n = e.uploads.find(
        (r) => r.uploadId === t.payload.detail.uploadId
      );
      n != null && n.hash && (n.hash = {
        ...n.hash,
        status: A.Cancelled
      }), x(e);
      break;
    }
    case "onStartHashCalculation": {
      const { uploadId: n } = t.payload, r = e.uploads.find((o) => o.uploadId === n);
      r != null && r.hash && (r.hash = {
        ...r.hash,
        status: A.Calculating
      }), x(e);
      break;
    }
    default:
      throw new Error("Invalid action type");
  }
}
const P = /* @__PURE__ */ new Map();
function Ct(e) {
  const t = We();
  return P.set(t, e), t;
}
function wt(e, t) {
  const r = !!localStorage.getItem("zustand-devtools-enabled"), o = lt()(
    pt(
      (i, _) => ({
        state: t,
        dispatch: (c) => {
          i(
            Te((f) => {
              At(f.state, c);
            }),
            void 0,
            c.type
          );
        },
        // Initialization function for setting up the uploader instance and event listeners
        init: (c) => {
          const f = _(), m = f.state.instanceId;
          i(
            Te(f, (a) => {
              const l = Ct(c);
              if (a.state = { ...t, instanceId: l }, a.state.instanceId = l, m) {
                const d = P.get(m);
                P.delete(m), d == null || d.cancelAllUploads();
              }
            }),
            void 0,
            "uploader/init"
          ), Dt(_());
        }
      }),
      {
        name: "UploadsStore",
        anonymousActionType: "anonymous",
        enabled: r !== null ? r : process.env.NODE_ENV === "development"
      }
    )
  );
  return o.getState().init(e), o;
}
function Dt({ state: e, dispatch: t }) {
  const n = P.get(e.instanceId);
  if (!n)
    throw new Error("AssetUploadManager instance not found");
  n.addEventListener(
    "assetAssigned",
    (r) => t({ type: "onAssetAssigned", payload: r })
  ), n.addEventListener(
    "uploadCreated",
    (r) => t({ type: "onUploadCreated", payload: r })
  ), n.addEventListener(
    "uploadProgress",
    (r) => t({ type: "onUploadProgress", payload: r })
  ), n.addEventListener(
    "uploadComplete",
    (r) => t({ type: "onUploadComplete", payload: r })
  ), n.addEventListener(
    "uploadCancelled",
    (r) => t({ type: "onUploadCancelled", payload: r })
  ), n.addEventListener(
    "metadataReceived",
    (r) => t({ type: "onMetadataReceived", payload: r })
  ), n.addEventListener(
    "thumbnailReceived",
    (r) => t({ type: "onThumbnailReceived", payload: r })
  ), n.addEventListener(
    "error",
    (r) => t({ type: "onError", payload: r })
  ), n.addEventListener(
    "hashComplete",
    (r) => t({ type: "onHashComplete", payload: r })
  ), n.addEventListener(
    "hashError",
    (r) => t({ type: "onHashError", payload: r })
  ), n.addEventListener(
    "hashCancelled",
    (r) => t({ type: "onHashCancelled", payload: r })
  ), n.addEventListener(
    "hashCalculationStarted",
    (r) => t({ type: "onStartHashCalculation", payload: r.detail })
  );
}
function R(e, t, n) {
  const r = C(e, ({ state: o }) => o.instanceId);
  ye(() => {
    if (!r || !n)
      return;
    const o = P.get(r);
    return o == null || o.addEventListener(t, n), () => {
      o == null || o.removeEventListener(t, n);
    };
  }, [t, n, r]);
}
const He = Qe(null);
function Z() {
  const e = qe(He);
  if (!e)
    throw new Error("useUploaderContext must be used within a UploaderProvider");
  return e;
}
const { Provider: Pt } = He;
function Rt(e) {
  const t = C(e, ({ state: r }) => r.instanceId), n = C(e, ({ state: r }) => {
    var o;
    return (o = r.uploads.find(Lt)) == null ? void 0 : o.uploadId;
  });
  ye(() => {
    const r = P.get(t);
    n && r && r.startUpload(n);
  }, [t, n]);
}
function Lt({ status: e }) {
  return e === E.Pending;
}
function Tt(e) {
  const t = C(e, ({ state: o }) => o.instanceId), n = C(e, ({ state: o }) => {
    var i;
    return (i = o.uploads.find(Nt)) == null ? void 0 : i.uploadId;
  }), r = C(
    e,
    ({ state: o }) => o.uploads.some(({ hash: i }) => i.status === A.Calculating)
  );
  ye(() => {
    const o = P.get(t);
    n && !r && (o == null || o.calculateHash(n));
  }, [r, t, n]);
}
function Nt({ hash: e }) {
  return e.status === A.Pending;
}
const zt = 5;
function Ht({
  portalId: e = "anonymous",
  userId: t = "anonymous",
  name: n,
  intent: r,
  children: o,
  withMetadata: i = !1,
  withHashing: _ = !1,
  maxConcurrentUploads: c = zt,
  onAssetAssigned: f,
  onFileUploadCreated: m,
  onFileUploadProgress: a,
  onFileUploadCompleted: l,
  onFileUploadError: d,
  onMetadataReceived: s,
  onThumbnailReceived: p,
  uploaderAdapterProvider: u = $e,
  webSocketProvider: v,
  getAuthorizationToken: y
}) {
  const h = Je();
  h.current || (h.current = wt(
    new ve({
      portalId: e,
      userId: t,
      name: n,
      options: { withMetadata: i, intent: r, withHashing: _ },
      uploaderAdapterProvider: u,
      webSocketProvider: v,
      getAuthorizationToken: y
    }),
    {
      ...Ge,
      maxConcurrentUploads: c,
      withHashing: _
    }
  )), Rt(h.current), Tt(h.current), R(h.current, "assetAssigned", f), R(h.current, "uploadCreated", m), R(h.current, "uploadProgress", a), R(h.current, "uploadComplete", l), R(h.current, "metadataReceived", s), R(h.current, "thumbnailReceived", p), R(h.current, "error", d);
  const g = Xe(() => {
    var D;
    const w = new ve({
      portalId: e,
      userId: t,
      name: n,
      options: { withMetadata: i, intent: r, withHashing: _ },
      uploaderAdapterProvider: u,
      getAuthorizationToken: y,
      webSocketProvider: v
    });
    (D = h.current) == null || D.getState().init(w);
  }, [
    e,
    t,
    n,
    i,
    _,
    r,
    u,
    y,
    v,
    h
  ]);
  return /* @__PURE__ */ Ke(Pt, { value: { store: h.current, resetUploader: g }, children: o });
}
function kt() {
  const e = Z(), t = C(e.store, ({ state: r }) => r.instanceId);
  if (!t)
    throw new Error("AssetUploadManager instanceId not found");
  const n = P.get(t);
  if (!n)
    throw new Error("AssetUploadManager instance not found");
  return n;
}
function Mt() {
  const e = Z(), t = kt();
  function n(s) {
    const p = e == null ? void 0 : e.store.getState().state.uploads.find((v) => v.file === s);
    let u = p == null ? void 0 : p.uploadId;
    return u || (u = t.createUpload(s)), u;
  }
  function r(s) {
    e == null || e.store.getState().dispatch({ type: "onUploadQueued", payload: { uploadId: s } });
  }
  function o(s) {
    return t.pauseUpload(s);
  }
  function i(s) {
    return t.resumeUpload(s);
  }
  function _(s) {
    return e == null || e.store.getState().dispatch({ type: "onUploadRemoved", payload: { uploadId: s } }), t.cancelUpload(s);
  }
  function c(s) {
    return t.cancelUpload(s);
  }
  function f(s) {
    return t.confirmUpload(s);
  }
  function m() {
    e == null || e.store.getState().dispatch({ type: "onQueueingAllUploads" });
  }
  function a() {
    return t.pauseAllUploads();
  }
  function l() {
    return t.resumeAllUploads();
  }
  function d() {
    return t.cancelAllUploads();
  }
  return {
    createUpload: n,
    startUpload: r,
    pauseUpload: o,
    resumeUpload: i,
    cancelUpload: c,
    confirmUpload: f,
    startAllUploads: m,
    pauseAllUploads: a,
    resumeAllUploads: l,
    cancelAllUploads: d,
    removeUpload: _,
    resetUploader: e.resetUploader,
    store: e.store
  };
}
function Bt(e) {
  const t = Z(), { startUpload: n, pauseUpload: r, removeUpload: o, cancelUpload: i, resumeUpload: _, confirmUpload: c } = Mt(), f = C(
    t.store,
    (l) => l.state.uploads.find((d) => d.uploadId === e)
  ), m = C(
    t.store,
    (l) => l.state.metadata[e]
  ), a = C(t.store, (l) => l.state.thumbnail[e]);
  if (!f)
    throw new Error(`Asset with id ${e} not found`);
  return {
    asset: {
      ...f,
      metadata: m,
      thumbnail: a,
      isPending: f.status === E.Pending,
      isUploading: f.status === E.Uploading,
      isPaused: f.status === E.Paused,
      isFailed: f.status === E.Failed,
      isUploaded: f.status === E.Uploaded,
      isCancelled: f.status === E.Cancelled
    },
    start: () => n(e),
    cancel: () => i(e),
    pause: () => r(e),
    resume: () => _(e),
    remove: () => o(e),
    confirm: () => c(e)
  };
}
function Ft() {
  const { store: e } = Z();
  return C(e, ({ state: n }) => n.uploads);
}
function Wt() {
  const e = Ft();
  return xt(e);
}
function xt(e) {
  const t = {
    size: 0,
    uploaded: 0,
    progress: 0,
    amountOfUploads: e.length
  };
  return e.forEach((n) => {
    t.size += n.file.size, t.uploaded += n.uploaded;
  }), t.size !== 0 && (t.progress = Math.ceil(t.uploaded / t.size * 100)), t;
}
export {
  ve as AssetUploadManager,
  Ht as UploaderProvider,
  $e as createAssetServiceAdapter,
  Qt as createFakeWebSocketProvider,
  qt as createFileServiceUploaderAdapter,
  Wt as useProgress,
  Bt as useUpload,
  Mt as useUploader,
  Ft as useUploads
};
